export type CarComponent = {
  totalResults: Number;
  returnedResults: Number;
  carComponents: Array<string>;
  pagination: string;
  countText: string;
};

export function getAPIRequest(endpoint: string, params: string) {
  const headers: Headers = new Headers();
  headers.set("Content-Type", "application/json");
  headers.set("Accept", "application/json");

  const baseURL = `${location.protocol}//${location.host}/cars-for-sale/api/v2`;
  const url = `${baseURL}/${endpoint}?${params}`;

  const request: RequestInfo = new Request(url, {
    method: "GET",
    headers: headers,
  });
  return request;
}
